import Vue from 'vue';
import { BlockDTO } from '../../../model/BlockDTO';

export async function favoriteProductsData(context: Vue, block: BlockDTO) {

	const favoriteProducts = await context.$apartmentService.fetchFavoriteApartments(context.$cookiesService.getFavoriteProducts().join());

	return {
		favoriteProducts,
	};
}
